// extracted by mini-css-extract-plugin
export var backLink = "style-module--back-link--93dd8";